import React, { Component } from 'react';
import { connect } from 'react-redux';
import formUrlEncoded from 'form-urlencoded';
import * as CryptoJS from "crypto-js";
import { remoteConfig } from '../../../../../config/config';
import * as jobActions from '../../../actions/jobs/jobs';
import * as purchaseActions from "../../../actions/transactions/purchases";
import * as basketActions from "../../../actions/transactions/basket";
import * as authActions from '../../../actions/authentication/authentication';
import * as cvActions from '../../../actions/cvservice/cvservice';
import { browserHistory } from 'react-router';
import LoginForm from './LoginForm';

class Login extends Component {
    state = {
        error: false
    }

    componentWillMount() {
        const { location, getRedirectUrl } = this.props;

        const redirectUrl = location.query.redirect,
            emailAddress = location.query.email,
            password = location.query.password;

        const itemId = location.query.item_id ? location.query.item_id : '';

        localStorage.setItem('stop_redirect', 0);

        if (redirectUrl) {
            localStorage.stop_redirect = 1;
            getRedirectUrl(redirectUrl, itemId);
        } else if (emailAddress && password) {

            if( !location.query.noHash ){
                const decodeUriPassword = decodeURIComponent(password),
                    decryptPassword = CryptoJS.AES.decrypt(decodeUriPassword, 'Encrypted Text'),
                    plainTextPassword = decryptPassword.toString(CryptoJS.enc.Utf8);

                return this.loginUser(null, emailAddress, plainTextPassword);
            };
            
            this.loginUser( null, emailAddress, password );
        }
    };

    componentWillUpdate(nextProps) {
        const { location } = this.props;

        const emailAddress = location.query.email,
            password = location.query.password;

        if (nextProps.redirectUrl) {
            if (emailAddress && password) {

                if( !location.query.noHash ){

                    const decodeUriPassword = decodeURIComponent(password),
                        decryptPassword = CryptoJS.AES.decrypt(decodeUriPassword, 'Encrypted Text'),
                        plainTextPassword = decryptPassword.toString(CryptoJS.enc.Utf8);

                    return this.loginUser(null, emailAddress, plainTextPassword);
                };

                this.loginUser( null, emailAddress, password );

            } else if (localStorage.unauthorized !== 1 && localStorage.token) {
                browserHistory.push(`${nextProps.redirectUrl}`);
            }
        }
    };

    loginUser(ev = null, autoEmail = null, autoPassword = null, formData) {
        const { redirectUrl, loginUser, resetJobSearchInitialValues, getPromotionalPricing } = this.props;
        
        let job_path = localStorage.job_path
        let job_search = localStorage.job_search

        let loginData = {};

        if (autoEmail !== null && autoPassword !== null) {
            loginData = {
                email_address: autoEmail,
                password: autoPassword,
            };
        } else {
            loginData = {
                email_address: formData.email,
                password: formData.password,
            };
        }

        fetch(`https://authentication.${remoteConfig.urls.api}/authentication/token`, {
            method: 'POST',
            body: formUrlEncoded(loginData),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        })
            .then((response) => {
                if (!response.ok) {
                    this.setState({ error: true })
                } else {
                    return response.json();
                }
            })
            .then((response) => {

                if (!response) return this.setState({ error: true });

                if (response.success) {
                    localStorage.setItem('created_person_at', response.data.created_at);
                    localStorage.setItem('unauthorized', 0);
                    localStorage.setItem('token', response.data.token);
                    localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
                    localStorage.setItem('person_id', response.data.person_id);
                    localStorage.setItem('reset_password', response.data.reset_password);
                    localStorage.setItem('first_login', response.data.first_login);
                    localStorage.setItem('loginAs', response.data.loginAs ? 1 : 0);
                    localStorage.setItem('free_account', response.data.free_account);
                    localStorage.setItem('email_address', loginData.email_address);
                    localStorage.setItem('changed_password', 0);
                    localStorage.setItem('site_of_origin', response.data.siteOfOrigin || 'gb');

                    getPromotionalPricing(loginData.email_address);

                    formData && formData.interest && cvActions.postCVInterest(response.data.person_id);

                    loginUser();
                    resetJobSearchInitialValues();

                    if (parseInt(localStorage.loginAs, 10) === 1) {
                        browserHistory.push('/');
                    }


                    if (redirectUrl !== null && typeof redirectUrl !== 'undefined') {
                        browserHistory.push(`${redirectUrl}`);
                    }
                    if (formData && formData.interest) {
                        browserHistory.push('/writing-services');
                    } 
                    if (job_path && job_search){
                        browserHistory.push(job_path + job_search);
                        localStorage.removeItem('job_path') 
                        localStorage.removeItem('job_search');
                    }
                    else {
                        localStorage.stop_redirect = 0;
                        browserHistory.push('/');
                    }

                }

                if (response.error) {
                    this.setState({ error: true })
                }
            })

            .catch(err => {
                console.error(err)
                this.setState({ error: true });
            });
    };

    render() {
        return (
            <article className="Site-content login-body">
                <LoginForm
                    error={this.state.error}
                    captureFormData={(formData) => this.loginUser(null, null, null, formData)} />
            </article>
        );
    };
}

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.authentication.isLoggedIn,
        isError: state.authentication.error.hasErrored,
        errorCode: state.authentication.error.errorCode,
        redirectUrl: state.authentication.redirectUrl,
        promotional_packages: state.transactions.promotional_packages,
        promotional_products: state.transactions.promotional_products,
        basket: state.transactions.basket,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loginUser: () => dispatch(authActions.loginUser()),
        hasErrored: code => dispatch(authActions.hasErrored(code)),
        resetJobSearchInitialValues: () => dispatch(jobActions.resetJobSearchInitialValues()),
        getPromotionalPricing: email => dispatch(purchaseActions.getPromotionPrices(email)),
        addProductToBasket: productId => dispatch(basketActions.addProductToBasket(productId)),
        addPackageToBasket: packageId => dispatch(basketActions.addPackageToBasket(packageId)),
        getRedirectUrl: (redirectUrl, itemId) => dispatch(authActions.getRedirectUrl(redirectUrl, itemId)),
        firstLoginBundlesAction: () => dispatch(authActions.firstLoginBundlesAction()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// src/client/components/common/authentication/Login.js